export default __webpack_public_path__ + "static/homepage_banner-2e4d75331ec6e1845e1c7026411c44a2.webp";